export default (params) => ({
  trigger: {
    name: 'content_blocks.compact_visual_entrances.show_content',
    params: params,
  },
  config: {
    schema: {
      title: {
        type: 'string',
      },
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'show_content_block',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
